export const outsideClick = (ref, callback) => {
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      document.removeEventListener('mousedown', handleClickOutside);
      callback();
    }
  }
  document.addEventListener('mousedown', handleClickOutside);
};
